/**
 * Created by daishuang on 2018/4/11.
 */
import share from 'api/share'
export function loginApi(data) {
    return share({
        url: '/api/login',
        method: 'post',
        data
    });
}

export function logout(data) {
    return share({
        url: `/api/logout`,
        method: 'post',
        data
    });
}

export function checkEmail(data) {
    return share({
        url: '/api/check_2fa_user',
        method: 'post',
        data
    });
}


// WEBPACK FOOTER //
// ./src/api/login.js